module.exports = __webpack_public_path__ + "img/druid.09b411e5.svg";